/* This class is a Injectable class which will act as singleton instance across application*/
import { Injectable } from '@angular/core';
import { ayObject } from '../interface/shared-interface';

// Declare class as injectable
@Injectable()
export class Globals {
    private static instance: Globals = Globals.getInstance();
    public app: ayObject;
    public serviceRoot: string;
    public webRoot: string;
    public applicationURL: string;

    public initMap: () => void;
    // Constructor will set
    private constructor() {
        this.app = {};
        this.initializeAppUrls();
        this.initializeResources();
    }

    // Return the instance of the service as singleton
    public static getInstance(): Globals {
        // set new instance if current instance is null
        if (Globals.instance === null || Globals.instance === undefined) {
            Globals.instance = new Globals();
        }

        return Globals.instance;
    }

    /* Function to be used to set value in global singleton object.*/
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    public setVal(key: string, val: any): void {
        this.app[key] = val;
    }

    /* Function to be used to get value from global singleton object based on key.*/
    public getVal(key: string): any {
        // if value set for the key then return the value else null
        if (this.app.hasOwnProperty(key)) {
            return this.app[key];
        } else {
            return null;
        }
    }

    /* Function to get all the global values set in the globals.*/
    public getAll(): ayObject {
        return this.app;
    }

    private initializeAppUrls(): void {
        const SLASH = '/';

        const serverURL = location.protocol + SLASH + SLASH + location.host;

        if (!serverURL.includes('localhost:')) {
            if (serverURL.includes('192.168.3.66:')) {
                this.applicationURL = `${serverURL}${SLASH}`;
                this.serviceRoot = 'http://192.168.3.66:8080';
                this.webRoot = 'http://192.168.3.66';
            } else {
                this.applicationURL = `${serverURL}${SLASH}`;
                if (!serverURL.includes('localhost')) {
                    this.serviceRoot = `${serverURL}/agyield-services`;
                    this.webRoot = serverURL;
                } else {
                    this.serviceRoot = 'http://localhost/agyields-services';
                    this.webRoot = 'http://localhost';
                }
            }
        } else {
            this.applicationURL = `${serverURL}${SLASH}`;
            this.serviceRoot = 'http://localhost:8080';
            this.webRoot = 'http://localhost';
        }
    }

    private initializeResources(): void {
        this.app['resources'] = {
            'ExportInspections': {
                header: 'Export Inspections',
                url: '//www.ams.usda.gov/mnreports/wa_gr101.txt',
            },
            'CropProgressReport': {
                header: 'Crop Progress Report',
                url: '//usda.library.cornell.edu/concern/publications/8336h188j?locale=en',
            },
            'EIAEthanol': {
                header: 'EIA Ethanol',
                url: '//www.eia.gov/dnav/pet/hist/LeafHandler.ashx?n=PET&s=W_EPOOXE_YOP_NUS_MBBLD&f=W',
            },
            'WESTable': {
                header: 'Weekly Export Sales (Table)',
                url: '//apps.fas.usda.gov/EXPORT-SALES/summfax.htm'
            },
            'WESHighlights': {
                header: 'Weekly Export Sales (Highlights)',
                url: '//apps.fas.usda.gov/EXPORT-SALES/highlite.htm'
            },
            'CFTCCommitment': {
                header: 'CFTC Commitment of Traders',
                url: '//www.cftc.gov/dea/options/ag_lof.htm'
            },
            'WASDESupplyDemand': {
                header: 'WASDE Supply & Demand',
                url: '//www.usda.gov/oce/commodity/wasde/index.htm'
            },
            'QuarterlyStocks': {
                header: 'Quarterly Stocks',
                url: '//usda.library.cornell.edu/concern/publications/xg94hp534?locale=en'
            },
            'StatsCanada': {
                header: 'Stats Canada',
                url: '//www.statcan.gc.ca/tables-tableaux/sum-som/l01/cst01/prim11b-eng.htm'
            },
            'AcerageReport': {
                header: 'Acreage Report (June)',
                url: '//usda.library.cornell.edu/concern/publications/j098zb09z?locale=en'
            },
            'ProspectivePlantings': {
                header: 'Prospective Plantings (March)',
                url: '//usda.library.cornell.edu/concern/publications/x633f100h?locale=en'
            },
            'FreeseNotis': {
                header: 'Freese-Notis',
                url: '//www.difluence.weather.net/cgi-bin/agyield.php?querystr=60606'
            },
            'ObservedPrecip': {
                header: 'Observed Precip',
                url: '//water.weather.gov/precip/index.php'
            },
            'ObservedPrecipDownload': {
                header: 'Observed Precip',
                url: '//water.weather.gov/precip/download.php'
            },
            'FOQuotesChart1': {
                header: 'Futures & Options Quotes',
                url: 'assets/html/Barchart1.html'
            },
            'FOQuotesChart2': {
                header: 'Future/Options Quotes Barchart2',
                url: 'assets/html/Barchart2.html'
            },
            'FOQuotesChart3': {
                header: 'Future/Options Quotes Barchart3',
                url: '//agyield.websol.barchart.com/?module=basicSearchForm'
            },
            'CashGrainQuotes': {
                header: 'Cash Grain Quotes',
                url: `${this.serviceRoot}/cgb/defaultCgb?userOrgId=`,
            },
            'AYMatrixCal': {
                header: '',
                url: `${this.serviceRoot}/calculator/forcastMatrix`,
            },
            'CattleCrushCal': {
                header: '',
                url: `${this.serviceRoot}/calculator/cattle`,
            },
            'InsuranceCal': {
                header: '',
                url: `${this.serviceRoot}/calculator/insurance_cal`,
            },
            'News': {
                header: 'News',
                url: 'assets/html/ResourceNewsListView.html',
            },
            'RawWeather': {
                header: 'Forecast Weather Summary',
                url:  `${this.serviceRoot}/services/weather/forecastWeatherReport`,
            },
            'ConsultingServices': {
                header: 'Market Commentary',
                url: '//agyield.com/resource-content/'
            },
            'Futures': {
                header: 'Futures',
                url: '//agyield.com/futures/'
            },
            'SpecialReports': {
                header: 'Special Reports',
                url: '//agyield.com/special-report1/'
            },
            'Options': {
                header: 'Options',
                url: '//agyield.com/options/'
            },
            'Margin': {
                header: 'Margin',
                url: '//agyield.com/margin-requirements/'
            },
            'CropIns': {
                header: 'Crop Insurance',
                url: '//agyield.com/crop-insurance/'
            },
            'Strategy1': {
                header: 'Buy a Put',
                url: '//agyield.com/simulatorbuy-a-put/'
            },
            'Strategy2': {
                header: 'Sell Cash contract and Buy a Call',
                url: '//agyield.com/sell-a-cash-contract-and-buy-a-call'
            },
            'Strategy3': {
                header: 'Sell Cash contract and Buy a Call Spread',
                url: '//agyield.com/sell-a-cash-contract-and-buy-a-call-spread/'
            },
            'Strategy4': {
                header: 'Buy a Put and Sell a Call(Collar)',
                url: '//agyield.com/buy-a-put-and-sell-a-call-collar'
            },
            'CashContracts': {
                header: 'Cash Contracts',
                url: '//agyield.com/cash-grain-contracts/'
            },
            'EveningLivestock': {
                header: 'Livestock Commentary',
                url: '//agyield.com/basic-evening-livestock-commentary/'
            },
            'BasicConsultingServices': {
                header: 'Basic Market Commentary',
                url: '//agyield.com/basic-resource-content/'
            },
            'BasicSpecialReports': {
                header: 'Basic Special Reports',
                url: '//agyield.com/report-for-basic/'
            },
            'BasicEveningLivestock': {
                header: 'Basic Livestock Commentary',
                url: '//agyield.com/basic-evening-livestock-commentary/'
            },
            'BamForecastUpdate': {
                header: 'BAM forecast update',
                url: '//agyield.com/bam-forecast-update/'
            }

        };
    }
}
